import React from 'react';
import './style.scss';
import { RandomizedUserBadgeColors } from '../../constants';
import { Props } from './model';

export function UserDisplay(props: Props) {
  return (
    <div className='user-display-w'>
      <div
        className={`user-badge ${props.disabled ? `disable-badge` : ''} `}
        style={{
          backgroundColor:
            RandomizedUserBadgeColors[
              props.firstName[0].toLowerCase().charCodeAt(0) % 97
            ],
        }}>
        {props.firstName[0]}
      </div>
      <div className='user-name-email'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}>
          <div className='user-name' title={props.firstName + ' ' + props.lastName}>
            {props.firstName + ' ' + props.lastName}{' '}
          </div>
          <span style={{ marginLeft: '5px' }}>
            {props.userEmail === sessionStorage.getItem('userEmail') ? '(You)' : ''}
          </span>
          {props.disabled ? <div className='user-disabled'>Disabled</div> : null}
        </div>
        <div className='user-email' title={props.userEmail}>
          {props.userEmail}
        </div>
      </div>
    </div>
  );
}
